import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';
import { Breadcrumb } from '@/components/ui/Breadcrumb';
import { PremiumUpgrade } from '@/components/premium/PremiumUpgrade';
import { useGlobalToast } from '@/contexts/ToastContext';

export function PremiumPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();
  const { success } = useGlobalToast();

  const isProvider = user?.role === 'provider';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!isProvider && user) {
      navigate('/dashboard');
    }
  }, [isProvider, navigate, user]);

  if (!isProvider) return null;

  const handleUpgrade = (planId: string) => {
    if (location.state?.from === 'jobs') {
      navigate('/jobs', { state: { from: 'dashboard' } });
    } else {
      navigate('/dashboard');
    }
  };

  const handleBack = () => {
    if (location.state?.from === 'jobs') {
      navigate('/jobs', { state: { from: 'dashboard' } });
    } else if (location.state?.from === 'dashboard') {
      navigate('/dashboard');
    } else {
      navigate(-1);
    }
  };

  const breadcrumbItems = [
    { label: 'Dashboard', href: '/dashboard' },
    { label: 'Upgrade Plan' }
  ];

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 pb-20">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-lg focus:shadow-lg min-h-touch">
        Skip to main content
      </a>
      <main id="main-content" role="main" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between mb-8">
          <Breadcrumb items={breadcrumbItems} onBack={handleBack} />
          <button
            onClick={handleBack}
            className="text-sm text-gray-600 hover:text-gray-900 flex items-center gap-1"
          >
            <ChevronLeft className="w-4 h-4" />
            Back
          </button>
        </div>

        <PremiumUpgrade onUpgrade={handleUpgrade} />
      </main>
    </div>
  );
}